import { memo, useRef } from 'react'

import { IContact } from 'clickNgo/entities/contact'
import { IContactFlags } from 'clickNgo/entities/contactFlag'
import { FieldGroup } from 'shared/components/fieldGroup'

import {
  ContactDetailsAdditional,
  ContactDetailsBasic,
  ContactDetailsContact,
  ContactDetailsFlags,
} from './content'

import styles from './ContactDetails.module.scss'

interface Props {
  contact: IContact
  contactFlags: IContactFlags
}

export const ContactDetails = memo<Props>(({ contact, contactFlags }) => {
  const { current: fieldGroupSize } = useRef(6)

  return (
    <div className={styles.contactDetails}>
      <FieldGroup
        title="Contact Details"
        size={fieldGroupSize}
        classNames={{
          group: styles.contactDetailsFieldGroup,
          groupTitle: styles.contactDetailsFieldGroupTitle,
          groupFields: styles.contactDetailsFieldGroupFields,
        }}
      >
        <ContactDetailsBasic contact={contact} />
        <ContactDetailsContact contact={contact} />
        <ContactDetailsAdditional contact={contact} />
        <ContactDetailsFlags contactFlags={contactFlags.UserRights} title="User rights" />
        <ContactDetailsFlags contactFlags={contactFlags.Campaigns} title="Campaigns" />
        <ContactDetailsFlags contactFlags={contactFlags.Tools} title="Tools" />
      </FieldGroup>
    </div>
  )
})
